var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timeOnly)?_c('span',{staticClass:"font-bold text-16 text-gray-900",class:{
    'text-red-600': _vm.breakMinutesRemaining < 0,
  }},[_vm._v(" "+_vm._s(_vm.timer)+" ")]):_c('div',{staticClass:"all:flex all:flex-col text-center text-gray-900 leading-tight bg-gray-100 p-2 rounded"},[_c('span',{staticClass:"font-bold text-30",class:{
      'text-red': _vm.breakMinutesRemaining < 0,
    }},[_vm._v(" "+_vm._s(_vm.timer)+" ")]),_c('span',{staticClass:"text-12"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }